import { TEXTS } from '../../constants';
import {
  SectionWrapper,
  ContentWrapper,
  CalendarOpenText,
  AlertFullWidth,
  AssigningText,
} from './styles';

const BookingStatusSection = ({
  assigningContact,
  practitionerName,
  calendarWindowRef,
  error,
  onCloseError,
}) => {
  const showSection =
    assigningContact ||
    (calendarWindowRef && !calendarWindowRef.closed) ||
    error;

  if (!showSection) return null;

  return (
    <SectionWrapper>
      <ContentWrapper>
        {assigningContact && (
          <AlertFullWidth severity="info">
            <AssigningText>
              {TEXTS.bookingStatus.assigning} {practitionerName}...
            </AssigningText>
          </AlertFullWidth>
        )}

        {calendarWindowRef && !calendarWindowRef.closed && (
          <CalendarOpenText>{TEXTS.bookingStatus.calendarOpen}</CalendarOpenText>
        )}

        {error && (
          <AlertFullWidth severity="warning" onClose={onCloseError}>
            {error}
          </AlertFullWidth>
        )}
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default BookingStatusSection;
